import { useReduxState } from 'hooks';
import { TwoFactorApps } from 'components/common/auth';
import { ProfileAuthTwoFactorSetup } from '.';

interface Props {
  isSharedConfiguration?: boolean;
  onActivated: () => Promise<void> | void;
  secret: string;
}

const ProfileAuthTwoFactorInfo = ({
  isSharedConfiguration = false,
  onActivated,
  secret
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="info">
      <p className="paragraph">
        {isSharedConfiguration
          ? messages.authTwoFactorInfoShared
          : messages.authTwoFactorInfo}
      </p>

      <p className="paragraph">{messages.authTwoFactorSetupOneInfo}</p>

      <TwoFactorApps />

      <div className="activate">
        <ProfileAuthTwoFactorSetup
          isSharedConfiguration={isSharedConfiguration}
          onActivated={onActivated}
          secret={secret}
        />
      </div>

      <style jsx>{`
        .info {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 400;
          padding: 15px;
        }
        .paragraph {
          margin: 0;
        }
        .paragraph:not(:first-child) {
          margin-top: 10px;
        }
        .activate {
          margin-top: 15px;
        }
      `}</style>
    </div>
  );
};

export default ProfileAuthTwoFactorInfo;
